// Backend phrase-library ids (validated against an allowlist server-side).
// Keep this the single source of truth so other fields can point at other
// libraries later without hardcoding string literals across the app.
export const ICBT_ASSESSMENTS_LIBRARY_ID = "icbtassessments";
